import { Outlet } from 'react-router-dom';
import Sidebar from '../components/Sidebar';
import MobileNav from '../components/MobileNav';
import Topbar from '../components/Topbar'; // 👈 NEW: We imported the Topbar!

const Dashboard = () => {
    return (
        <div className="min-h-screen bg-[#090514] text-white font-sans selection:bg-pink-500 selection:text-white pb-24 md:pb-0">
            
            {/* 1. Desktop Floating Sidebar */}
            <Sidebar />

            {/* 2. Content Area */}
            <div className="flex-1 flex flex-col md:pl-[290px] md:pr-4 min-h-screen transition-all duration-300">
                
                {/* 👈 NEW: Render the Topbar right here! This runs the branch logic. */}
                <Topbar />

                {/* 3. Main Outlet */}
                <main className="relative z-10 px-4 md:px-0 mt-4 md:mt-6">
                    <Outlet />
                </main>

            </div>

            {/* 4. Mobile Bottom Nav */}
            <MobileNav />

            {/* Background Atmosphere */}
            <div className="fixed top-[-20%] right-[-10%] w-[600px] h-[600px] bg-purple-600/10 rounded-full blur-[120px] pointer-events-none z-0"></div>
            <div className="fixed bottom-[-20%] left-[-10%] w-[600px] h-[600px] bg-pink-600/10 rounded-full blur-[120px] pointer-events-none z-0"></div>
        </div>
    );
};

export default Dashboard;